import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import ContentSections from "./components/ContentSections";
import ArticleGrid from "./components/ArticleGrid";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL;

  useEffect(() => {
    document.title = "Superbuy Spreadsheet Guide 2026 - Best Shopping Resources & QC Tips";
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main>
        <HeroSection />
        <CategoryGrid />
        <ContentSections />
        <ArticleGrid />
        <CTASection />
        <FAQSection />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebSite",
              "name": "Superbuy Spreadsheet Forum",
              "url": siteUrl,
              "description": "Find the best Superbuy Spreadsheet resources, shopping guides, QC tutorials, shipping advice, and buying tips.",
              "potentialAction": {
                "@type": "SearchAction",
                "target": `${siteUrl}/?q={search_term_string}`,
                "query-input": "required name=search_term_string",
              },
            }),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "Superbuy Spreadsheet Forum",
              "url": siteUrl,
              "description": "Independent informational resource providing Superbuy Spreadsheet guides, QC tutorials, shipping advice, and buying tips.",
              "sameAs": [
                "https://kaspreadsheet.com/",
              ],
            }),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Home",
                  "item": siteUrl,
                },
              ],
            }),
          }}
        />
      </main>

      <Footer />
    </div>
  );
}